import Chart from "chart.js/auto";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { CategoryScale } from "chart.js";
import "./assets/css/animate.min.css";
import "./assets/css/demo.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
Chart.register(CategoryScale);

import AdminLayout from "layouts/Admin.js";
import User from "layouts/User";
import Dashboard from "views/Dashboard";
import ForgotPwd from "views/ForgotPwd";
import MultiStepForm from "views/signup/SignupMultiStep";
import SignupReferent from "views/SignupReferent";
import UnlockPage from "views/UnlockPage";
import PrivateRoute from "./components/privateRoute";
import Login from "./views/Login";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/signup" component={MultiStepForm} />
      <Route path="/forgotpwd" component={ForgotPwd} />
      <Route path="/unlock" component={UnlockPage} />
      <Route path="/result" component={Dashboard} />
      <Route path="/signup-referent" component={SignupReferent} />
      <PrivateRoute
        path="/admin"
        component={AdminLayout}
        requiredRole={["admin", "referent"]}
      />
      <PrivateRoute
        path="/referent"
        component={AdminLayout}
        requiredRole={["referent"]}
      />
      <PrivateRoute path="/user" component={User} requiredRole="candidate" />
      <Redirect from="/" to="/admin/dashboard" />
    </Switch>
  </BrowserRouter>
);
